/*-------------------------------------------------------
||Program           : Vouchers.jsx
||Application       : Voucher
||Option            : Voucher Listing
||Developer         : Ashish Kumar
||Date              : 2026-03-19
----------------------------------------------------------*/

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, InputGroup, Form, Modal } from "react-bootstrap";
import Moment from "moment";
import filterIcon from "./../../assets/images/filter-gray.svg";
import Select from "react-select";
import VoucherService from "../../services/VoucherService";
import Alerts from "../common/Alerts";
import NoDataSearch from "../common/NoDataSearch";
import { Link } from "react-router-dom";

export class Vouchers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      total_record: 0,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      status: "",
      selectedStatus: null,
      voucher_code: "",
      confirmation_code: "",
      tableQueryString: "",
      customQueryString: "",
      filter_value: "",
      isSearch: global.isSearch,
      is_search: 0,
      module_search: "",
      isSubmit: false,
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "id",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      columns: [
        {
          key: "voucher_code",
          text: "Voucher Code",
          sortable: true,
          cell: (record) =>
            record.voucher_code ? (
              <Link to={`/vouchers/${record.voucher_code}`}>
                {record.voucher_code || ""}
              </Link>
            ) : (
              ""
            ),
        },
        {
          key: "guest_name",
          text: "Guest",
          sortable: false,
          cell: (record) =>
            `${record.guest_first_name || ""} ${record.guest_last_name || ""}`.trim(),
        },
        {
          key: "guest_email",
          text: "Guest Email",
          sortable: false,
          cell: (record) => record.guest_email || "",
        },
        {
          key: "confirmation_code",
          text: "Confirmation Code",
          sortable: true,
          cell: (record) => record.confirmation_code || "",
        },
        {
          key: "amount",
          text: "Amount",
          sortable: true,
          cell: (record) => `$${record.amount || 0}`,
        },
        {
          key: "status",
          text: "Status",
          sortable: true,
          cell: (record) => record.status || "",
        },
        {
          key: "is_promo_code",
          text: "Type",
          sortable: false,
          cell: (record) =>
            record.is_promo_code ? (
              <span className="badge badge-info round-0">Promo</span>
            ) : (
              <span className="badge badge-secondary">Voucher</span>
            ),
        },
        {
          key: "expiry_date",
          text: "Expiry",
          sortable: true,
          cell: (record) =>
            record.expiry_date
              ? Moment(record.expiry_date).format(global.dateFormat)
              : "",
        },
        {
          key: "used_at",
          text: "Used At",
          sortable: true,
          cell: (record) =>
            record.used_at
              ? Moment(record.used_at).format(global.dateFormat)
              : "",
        },
        {
          key: "created_at",
          text: "Created",
          sortable: true,
          cell: (record) =>
            record.created_at
              ? Moment(record.created_at).format(global.dateFormat)
              : "",
        },
      ],
    };

    this.filterData = this.filterData.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.tableChangeHandler = this.tableChangeHandler.bind(this);
    this.searchToggle = this.searchToggle.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  async getData(queryString = "") {
    let res = await VoucherService.getVouchers(queryString);
    if (global.successStatus.includes(res.status)) {
      this.setState({
        records: res.data?.data ? res.data.data : [],
        total_record: res.data?.total ? res.data.total : 0,
      });
    } else {
      this.setState({ records: [], total_record: 0 });
    }
  }

  filterData() {
    let queryString =
      "status=" +
      (this.state.status ? this.state.status : "") +
      "&voucher_code=" +
      (this.state.voucher_code ? this.state.voucher_code : "") +
      "&confirmation_code=" +
      (this.state.confirmation_code ? this.state.confirmation_code : "");

    let moduleSearchString = "";
    moduleSearchString = this.state.status
      ? moduleSearchString
        ? moduleSearchString +
          " ," +
          " Status - " +
          (this.state.selectedStatus
            ? this.state.selectedStatus.label
            : this.state.status)
        : " Status - " +
          (this.state.selectedStatus
            ? this.state.selectedStatus.label
            : this.state.status)
      : moduleSearchString;
    moduleSearchString = this.state.voucher_code
      ? moduleSearchString
        ? moduleSearchString +
          " ," +
          " Voucher Code - " +
          this.state.voucher_code
        : " Voucher Code - " + this.state.voucher_code
      : moduleSearchString;
    moduleSearchString = this.state.confirmation_code
      ? moduleSearchString
        ? moduleSearchString +
          " ," +
          " Confirmation Code - " +
          this.state.confirmation_code
        : " Confirmation Code - " + this.state.confirmation_code
      : moduleSearchString;

    this.setState({ customQueryString: queryString });
    this.searchToggle();
    this.setState({ is_search: 1 });
    this.setState({ module_search: moduleSearchString.split(",") });
    this.getData(queryString);
  }

  clearFilter() {
    this.setState(
      {
        status: "",
        selectedStatus: null,
        voucher_code: "",
        confirmation_code: "",
        customQueryString: "",
        filter_value: "",
        is_search: 0,
        module_search: "",
      },
      () => this.getData(),
    );
  }

  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      this.setState({ isSearch: 1 });
    }
  };

  changeHandler = (event) => {
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({ [event.target.name]: value });
  };

  handleStatusChange(value) {
    this.setState({
      selectedStatus: value,
      status: value ? value.value : "",
    });
  }

  tableChangeHandler(data) {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "page_size") {
            newKey = "per_page";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += this.state.customQueryString
        ? "&" + this.state.customQueryString
        : "";
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getData(queryString),
          global.filter_time,
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getData(queryString);
    }
  }

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
              ? "black"
              : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };
    const statusOptions = [
      { value: "active", label: "Active" },
      { value: "used", label: "Used" },
      { value: "expired", label: "Expired" },
    ];
    return (
      <>
        <main className="voucher-listing-page">
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                <div className="col-md-12">
                  <div className="col-md-12 mg-t-20 mg-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>Vouchers</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {global.userPermissions.checkPermission(
                          "reservations-add",
                        ) && (
                          <button
                            onClick={() =>
                              this.props.history.push("/vouchers/create")
                            }
                            className="btn-success-outline-small ml-3"
                          >
                            Add
                          </button>
                        )}
                        <button
                          onClick={this.searchToggle}
                          className="btn-success-outline-small ml-3"
                        >
                          <img src={filterIcon} alt="filterIcon" />{" "}
                          {this.state.isSearch === 1 ? "Search" : "Search"}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="scrolling-carousel pd-l-15 pd-r-15">
                    <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                      <div className="col-md-12 pd-l-30 pd-r-30">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>

                      {this.state.is_search === 1 ? (
                        <>
                          <div className="col-xxl-12 col-sm-12 pd-lg-r-15 pd-lg-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                            <div className="custm-filter">
                              <div>
                                {" "}
                                <label className="form-label text-left pd-b-2 mb-0">
                                  Search Applied On
                                </label>
                              </div>
                              <div className="filter_bg_cust">
                                {this.state.module_search.map((item, i) => {
                                  return <span key={i}>{item}</span>;
                                })}
                                <button
                                  onClick={this.clearFilter}
                                  className="btn-fliter-clear"
                                >
                                  Clear
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}

                      {this.state.total_record > 0 ||
                      this.state.filter_value !== "" ? (
                        <div className="row d-block mg-t-18 brandList ml-0 p-l-4 pd-r-0">
                          <div className="pd-lg-l-0 pd-xs-l-15 pd-lg-r-0 pd-xs-r-15">
                            <ReactDatatable
                              className="table no-wrap mg-b-30 pd-b-2 text-align-left"
                              config={this.state.config}
                              records={this.state.records}
                              columns={this.state.columns}
                              dynamic={true}
                              total_record={this.state.total_record}
                              onChange={this.tableChangeHandler}
                            />
                          </div>
                        </div>
                      ) : (
                        <NoDataSearch msg="No vouchers found." />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>
        {/* Module search popup modal */}
        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.searchToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Search in Vouchers</h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Status</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      menuPlacement="auto"
                      value={this.state.selectedStatus}
                      options={statusOptions}
                      onChange={(value) => this.handleStatusChange(value)}
                      defaultValue={this.state.selectedStatus}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Voucher Code</label>
                  <div className="col-md-12 p-0">
                    <Form.Control
                      onChange={this.changeHandler}
                      name="voucher_code"
                      value={this.state.voucher_code}
                      className="form-control max_width_100"
                      id="inlineFormInput"
                      type="text"
                      maxLength="50"
                      autoComplete="off"
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Confirmation Code</label>
                  <div className="col-md-12 p-0">
                    <Form.Control
                      onChange={this.changeHandler}
                      name="confirmation_code"
                      value={this.state.confirmation_code}
                      className="form-control max_width_100"
                      id="inlineFormInput"
                      type="text"
                      maxLength="50"
                      autoComplete="off"
                    />
                  </div>
                </InputGroup>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.searchToggle()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.filterData}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Search"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Vouchers;
